import React, {
	useEffect,
	useState
}from "react"
import {
	 Modal, Form, Select
}from "antd"
import {
	useSelector,
	useDispatch
}from 'react-redux'
import {
	useDebounce
}from "use-debounce"
import CustomButton from "../../../components/CustomButton"
import CustomInput from "../../../components/CustomInput"
import Notifications from "../../../helpers/Notifications"
import CustomSelect from "../../../components/CustomSelect"
import {
	reAddressTypeActions
}from "../ReAddressType/store/actions"
import {
	reAdministrativeTerritoryActions
}from '../ReAdministrativeTerritory/store/actions'
const { Option } = Select

const ReAddressChangeForm = (props) => {
	const { visible, setVisible, setRecord, record, create, update } = props
	const dispatch = useDispatch()
	const { isSending, changed } = useSelector((state) => state.reAddressReducer)
	const { list : AdministrativeTerritories } = useSelector(state => state.reAdministrativeTerritoryReducer)
	const addressTypes = useSelector(state => state.reAddressTypeReducer.list)
	const [searchAdministrativeTerritory, setSearchAdministrativeTerritory] = useState(null)
	const [administrativeTerritory] = useDebounce(searchAdministrativeTerritory, 500)
	const [searchAddressType, setSearchAddressType] = useState('')
	const [addressType] = useDebounce(searchAddressType, 500)
	const [form] = Form.useForm()

	const getAdminTerritories = (values) => {
		dispatch(reAdministrativeTerritoryActions.getList(values))
	}

	useEffect(() => {
		return () => {
			dispatch(reAddressTypeActions.clear())
			dispatch(reAdministrativeTerritoryActions.clear())
		}
	}, [])

	useEffect(() => {
		if (searchAdministrativeTerritory?.trim()){
			getAdminTerritories({ name     : searchAdministrativeTerritory?.trim(),
				pageSize : 100 })
		}
	}, [administrativeTerritory])

	const getAddressType = (values) => {
		dispatch(reAddressTypeActions.getList(values))
	}

	useEffect(() => {
		getAddressType({
			name: addressType
		})
	}, [addressType])

	useEffect(() => {
		form.resetFields()
		if (record){
			getAdminTerritories({ name     : record.reATerName,
				pageSize : 100 })
			getAddressType({
				name: record.reAddressTypeName
			})
			form.setFieldsValue({
				id                      : record?.id,
				code                    : record.code,
				name                    : record.name,
				addressType             : record?.reAddressTypeId,
				administrativeTerritory : record?.reATerNumId
			})
		}
	}, [record])

	useEffect(() => {
		if (changed)
			handleCancel()
	}, [changed])

	function handleCancel(){
		form.resetFields()
		setVisible(false)
		setRecord(null)
	}

	const save = () => {
		form.validateFields().then(values => {
			const updateValues = {
				id              : record?.id,
				code            : values.code,
				name            : values.name.trim(),
				reAddressTypeId : values.addressType,
				reATerNumId    	: values.administrativeTerritory,
				createDate      : record?.createDate,
				isDeleted       : record?.isDeleted
			}
			const previousValues = {
				id              : record?.id,
				code            : record?.code,
				name            : record?.name,
				reAddressTypeId : record?.reAddressTypeId,
				reATerNumId     : record?.reATerNumId,
				createDate      : record?.createDate,
				isDeleted       : record?.isDeleted
			}
			if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
				Notifications.errorNotice("Введенные вами данные полностью соответствуют изначальным.", null, 20)
			else
				record ? update(updateValues) : create(updateValues)
		})
	}

	return (
		<Modal
			destroyOnClose
			footer={ [
				<CustomButton
					key="save"
					loading={ isSending }
					type="green"
					onClick={ save }
				>
          Сохранить
				</CustomButton>
			] }
			title={ record ? "Редактирование записи" : "Добавление записи" }
			visible={ visible }
			width={ 900 }
			onCancel={ handleCancel }
		>
			<Form
				form={ form }
				labelAlign="left"
				labelCol={ { span: 6 } }
				name="nsi-form"
				wrapperCol={ { span   : 16,
					offset : 1 } }
			>
				<Form.Item
					label="Код"
					name="code"
					rules={ [
						{
							required : true,
							message  : "Код заполнен некорректно.",
							pattern  : /^[1-9]\d{0,6}$/
						}
					] }
				>
					<CustomInput
						placeholder="Введите код"
						readOnly={ Boolean(record) }
					/>
				</Form.Item>
				<Form.Item
					label="Населённый пункт"
					name="administrativeTerritory"
					rules={ [
						{
						  required : true,
						  message  : 'Введите населённый пункт'
						}
					] }
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={ false }
						mode="single"
						notFoundContent={ null }
						placeholder="Введите название населенного пункта "
						onSearch={ (value) => setSearchAdministrativeTerritory(value) }
					>
						{ AdministrativeTerritories?.map(territory => (
							<Select.Option
								key={ territory.reATerNumId }
								title={ territory.name }
								value={ territory.reATerNumId }
							>
								{ territory.name }
							</Select.Option>
						)) }
					</CustomSelect>
				</Form.Item>
				<Form.Item
					label="Тип улицы"
					name="addressType"
					rules={ [{ required: true }] }
				>
					<CustomSelect
						allowClear
						showSearch
						filterOption={ false }
						notFoundContent={ null }
						placeholder="Выберите тип улицы"
						onSearch={ (e) => setSearchAddressType(e) }
					>
						{ addressTypes?.map(item => {
							return (
								<Option
									key={ item.id }
									value={ item.id }
								>
									{ item.name }
								</Option>)
						}) }
					</CustomSelect>
				</Form.Item>
				<Form.Item
					label="Наименование"
					name="name"
					rules={ [
						{
							required   : true,
							whitespace : true,
							min        : 3,
							max        : 200
						}
					] }
				>
					<CustomInput
						maxLength={ 250 }
						placeholder="Введите наименование"
					/>
				</Form.Item>
			</Form>
		</Modal>
	)
}
export default ReAddressChangeForm
